import fa from "element-ui/src/locale/lang/fa";

const merge = require('webpack-merge')

let config = {
  TOKEN_KEY: "stoken"
}

const customName = process.env.CONF_CUSTOM

const customConfig = {
  // 安徽省合肥市庐州公证处
  lz:{
    // baseURL: 'https://hflzgzc.houmagongzheng.cn/web',
    baseURL: '/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'安徽省合肥市庐州公证处',
    CUSTOM_CODE:'lz',
    hiddenQr:true,
    hiddenLoginBtn: true,
    // menus: 27, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 江苏省南京市石城公证处
  sc:{
    // baseURL: 'https://njscgzc.houmagongzheng.cn/web',
    baseURL: '/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'江苏省南京市石城公证处',
    CUSTOM_CODE:'sc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 咸阳市公证处
  xy:{
    // baseURL: 'https://xygzc.houmagongzheng.cn/web',
    baseURL: '/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'咸阳市公证处',
    CUSTOM_CODE:'xy',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 内蒙古自治区包头市方正公证处
  fz:{
    // baseURL: 'https://btfzgzc.houmagongzheng.cn/web',
    baseURL: '/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'内蒙古自治区包头市方正公证处',
    CUSTOM_CODE:'fz',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 山西省侯马市公证处
  hm:{
    // baseURL: 'https://hmgzc.houmagongzheng.cn/web',
    baseURL: '/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'山西省侯马市公证处',
    CUSTOM_CODE:'hm',
    mapImg:'hm',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 浙江省淳安县公证处
  caxgzc:{
    // baseURL: 'https://caxgzc.houmagongzheng.cn/web',
    baseURL: '/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'浙江省淳安县公证处',
    CUSTOM_CODE:'caxgzc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 重庆市丰都县公证处
  cqfdgzc:{
    // baseURL: 'https://fdgzc.ebaoquan.com/web',
    baseURL: '/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'重庆市丰都县公证处',
    CUSTOM_CODE:'cqfdgzc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 辽宁省庄河市公证处
  lnzhgzc:{
    // baseURL: 'https://www.lnzhgzc.cn/web',
    baseURL: '/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'辽宁省庄河市公证处',
    CUSTOM_CODE:'lnzhgzc',
    mapImg:'lnzhgzc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1000010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 吉林省长春市春信公证处
  jlcccxgzc:{
    // baseURL: 'https://jlcccxgzc.houmagongzheng.cn/web',
    baseURL: '/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'吉林省长春市春信公证处',
    CUSTOM_CODE:'jlcccxgzc',
    hiddenQr:true,
    hiddenLoginBtn: false,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 广东省江门市五邑公证处
  gdjmwygzc:{
    // baseURL: 'https://finance.wygzc.cn/web',
    baseURL: '/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'广东省江门市五邑公证处',
    CUSTOM_CODE:'gdjmwygzc',
    hiddenQr:true,
    hiddenLoginBtn: false,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 重庆市永川公证处
  ycgzc:{
    // baseURL: 'http://cqyc.ycgzc.com.cn/web',
    baseURL: '/web',
    ebqAccount:'http://account.ycgzc.com.cn',
    NOTAR_WBQ: 'http://wbq.ycgzc.com.cn/',//公证取证
    NOTAR_JZQ: 'http://jzq.ycgzc.com.cn/',//公证电子签
    CUSTOM_TEST:'重庆市永川公证处',
    CUSTOM_CODE:'ycgzc',
    thirdAuthId: 15, //跳转到易保全登录的ID
    mapImg:'ycgzc',
    hiddenQr:true,
    hiddenLoginBtn: false,
    hiddenEMailLogin:true, // 登录注册隐藏邮箱方式
    menus: 0b1111110, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 辽宁省抚顺市法信公证处
  lnfsfxgzc:{
    // baseURL: 'https://lnfsfxgzc.houmagongzheng.cn/web',
    baseURL: '/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'辽宁省抚顺市法信公证处',
    CUSTOM_CODE:'lnfsfxgzc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b0011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 甘肃省兰州飞天公证处
  gslzftgzc:{
    // baseURL: 'https://gslzftgzc.houmagongzheng.cn/web',
    baseURL: '/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'甘肃省兰州飞天公证处',
    CUSTOM_CODE:'gslzftgzc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 云南省昆明市国正公证处
  ynkmgz:{
    // baseURL: 'https://ynkmgz.houmagongzheng.cn/web',
    baseURL: '/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'云南省昆明市国正公证处',
    CUSTOM_CODE:'ynkmgz',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 鹤城公证处
  hc:{
    // baseURL: 'http://dadi.hcgzc.org.cn:58088/web',
    baseURL: '/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'鹤城公证处',
    CUSTOM_CODE:'hc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 河北省唐山市华忆公证处
  hbtshy:{
    // baseURL: 'https://hbtshygzc.houmagongzheng.cn/web',
    baseURL: '/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'河北省唐山市华忆公证处',
    CUSTOM_CODE:'hbtshy',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 黑龙江省哈尔滨国信公证处
  hljgxgz:{
    // baseURL: 'https://xsfq.hljgxgz.com/web',
    baseURL: '/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'黑龙江省哈尔滨国信公证处',
    CUSTOM_CODE:'hljgxgz',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 湖南省湘潭市湖湘公证处
  hnxthxgzc:{
    // baseURL: 'https://hnxthxgzc.houmagongzheng.cn/web',
    baseURL: '/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'湖南省湘潭市湖湘公证处',
    CUSTOM_CODE:'hnxthxgzc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 重庆市中信公证处
  zxgzc:{
    // baseURL: 'https://cqzxgz.egz360.com/web',
    baseURL: '/web',
    ebqAccount:'https://cqzxact.egz360.com',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: 'https://cqzxjzq.egz360.com',//公证电子签
    CUSTOM_TEST:'重庆市中信公证处',
    CUSTOM_CODE:'zxgzc',
    mapImg:'zxgzc',
    thirdAuthId: 12, //跳转到易保全登录的ID
    hiddenQr:true,
    hiddenLoginBtn: false,
    menus: 0b1011110, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 辽宁省大连市法原公证处
  lnfygzc:{
    // baseURL: 'https://ybq.yuanfagongzheng.com/web',
    baseURL: '/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'辽宁省大连市法原公证处',
    CUSTOM_CODE:'lnfygzc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 重庆市渝信公证处
  cqyxgzc:{
    baseURL: '/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'重庆市渝信公证处',
    CUSTOM_CODE:'cqyxgzc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 重庆市渝北公证处
  cqybgzc:{
    // baseURL: 'https://cqybgz.egz360.com/web',
    baseURL: '/web',
    ebqAccount:'https://cqybact.egz360.com',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: 'https://cqybjzq.egz360.com',//公证电子签
    CUSTOM_TEST:'重庆市渝北公证处',
    CUSTOM_CODE:'cqybgzc',
    mapImg:'cqybgzc',
    thirdAuthId: 13, //跳转到易保全登录的ID
    mobile_front_url:"/m",
    hiddenQr:false,
    hiddenLoginBtn: true,
    menus: 0b1011110, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 江西省南昌县公证处
  jxncgzc:{
    // baseURL: 'https://cqybgz.egz360.com/web',
    baseURL: '/web',
    ebqAccount:'https://ncgzcjzqa.ebaoquan.com',
    NOTAR_WBQ: 'https://ncgzcwbq.ebaoquan.com',//公证取证
    NOTAR_JZQ: 'https://ncgzcjzq.ebaoquan.com',//公证电子签
    CUSTOM_TEST:'江西省南昌县公证处',
    CUSTOM_CODE:'jxncgzc',
    mapImg:'jxncgzc',
    thirdAuthId: 1, //跳转到易保全登录的ID
    mobile_front_url:"/m",
    hiddenQr:false,
    hiddenLoginBtn: true,
    menus: 0b1011110, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 重庆市公证处
  cqgzc:{
    // baseURL: 'https://cqybgz.egz360.com/web',
    baseURL: '/web',
    ebqAccount:'https://account.cqgz.cn',
    NOTAR_WBQ: 'https://wbq.cqgz.cn',//公证取证
    NOTAR_JZQ: 'https://jzq.cqgz.cn',//公证电子签
    CUSTOM_TEST:'重庆市公证处',
    CUSTOM_CODE:'cqgzc',
    thirdAuthId: 16, //跳转到易保全登录的ID
    mobile_front_url:"/m",
    mapImg:'cqgzc',
    hiddenQr:false,
    hiddenLoginBtn: true,
    menus: 0b1111110, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 辽宁省鞍山市鞍山公证处
  lnassgzc:{
    // baseURL: 'https://cqybgz.egz360.com/web',
    baseURL: '/web',
    ebqAccount:'https://account.assgzc.com',
    NOTAR_WBQ: 'https://wbq.assgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.assgzc.com',//公证电子签
    CUSTOM_TEST:'辽宁省鞍山市鞍山公证处',
    CUSTOM_CODE:'lnassgzc',
    thirdAuthId: 17, //跳转到易保全登录的ID
    mobile_front_url:"/m",
    mapImg:'lnassgzc',
    hiddenQr:false,
    hiddenLoginBtn: true,
    menus: 0b1111110, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 辽宁省抚顺市法信公证处
  lnfsfxgzcNew:{
    // baseURL: 'https://lnfsfxgzc.houmagongzheng.cn/web',
    baseURL: '/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'辽宁省抚顺市法信公证处',
    CUSTOM_CODE:'lnfsfxgzcNew',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b0011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
  // 延吉市至诚公证处
  yjzcgz:{
    // baseURL: 'https://ybq.yuanfagongzheng.com/web',
    baseURL: '/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'延吉市至诚公证处',
    CUSTOM_CODE:'yjzcgz',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b1011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
  },
};

console.log(33333333333,process.env.CONF_CUSTOM,customConfig['ys'])


if (process.env.CONF_ENV === 'production') {
  if(customName !== 'undefined' && customConfig[customName]){
    config = merge(config,{
      domain:customConfig[customName]
    });
  }else{
    config = merge(config, {
      domain: {
        baseURL: 'https://whzcgz.ebaoquan.com/web',
        ebqAccount:'https://jzqa.jxsncxgzc.com',
        NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
        NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
        hiddenJZQ:true,
      }
    });
  }

} else if (process.env.CONF_ENV === 'sandbox') {
  config = merge(config, {
    domain: {
      baseURL: '/web',
      ebqAccount:'http://account.demo.ebq.bz',
      mobile_front_url:"/m",
      video_front_url: 'https://rtc-sandbox.ebaoquan.com',
      VIDEO_SERVER_API: '/video',
      NOTAR_WBQ: 'http://wbq.demo.ebq.bz',//公证取证
      NOTAR_JZQ: 'http://jzq.demo.ebq.bz',//公证电子签
      thirdAuthId: 3, //跳转到易保全登录的ID
      SMART_NOTAR_WEB_URL:'/smart',
      hiddenJZQ:true,
      mapImg:'ysgz',
    }
  });
} else {
  config = merge(config, {
    domain: {
      // baseURL:'https://whzcgz.ebaoquan.com/web',
      baseURL: 'http://nxfqgz.demo.ebq.bz/web',
      // baseURL: 'https://www.lnzhgzc.cn/web',
      // baseURL: 'http://whzc.demo.ebq.bz/web',
      // baseURL: 'http://192.168.169.119:9001/web',
      // baseURL: 'http://192.168.169.101:9001/web',
      // baseURL: 'http://localhost:8080/ccss',
      ebqAccount: 'https://jzqa.jxsncxgzc.com',
      mobile_front_url: "/m",
      video_front_url: 'https://rtc-sandbox.ebaoquan.com',
      // VIDEO_SERVER_API: 'http://192.168.169.22:9003/video',
      VIDEO_SERVER_API: 'http://nxfqgz.demo.ebq.bz/video',
      NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
      NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
      CUSTOM_CODE:'lz',
      mapImg:'ysgz',
      // hiddenQr:true,
      // hiddenLoginBtn: false,
      // hiddenEMailLogin:true, // 登录注册隐藏邮箱方式
      menus: 0b1011111, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证 64:取证保管函
    }
  });
}
export default config



// WEBPACK FOOTER //
// ./src/config/index.js